<template>
  <div class="capillary-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>h = 2γcosθ / (ρgr)$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- Background Liquid -->
          <rect x="0" y="180" width="400" height="60" fill="rgba(0, 111, 253, 0.2)" />
          
          <!-- Test Tubes -->
          <g v-for="(tube, index) in tubes" :key="index">
            <!-- Tube Body -->
            <rect :x="100 + index * 100" y="40" :width="tube.width" height="150" fill="none" stroke="rgba(255,255,255,0.2)" />
            
            <!-- Liquid in Tube -->
            <path :d="calculateLiquidPath(tube, index)" :fill="tube.isWetting ? 'rgba(0, 111, 253, 0.4)' : 'rgba(128, 128, 128, 0.4)'" />
            
            <!-- Tube Label -->
            <text :x="100 + index * 100" y="210" fill="#888" font-size="10">{{ tube.label }} (r={{ tube.radius }})</text>
          </g>
          
          <!-- Surface Tension Molecules -->
          <g v-if="showMolecules">
            <circle v-for="n in 5" :key="'m'+n" :cx="150 + n*10" :cy="180" r="3" fill="#00d2ff" opacity="0.6">
               <animate attributeName="cy" values="180;175;180" dur="2s" :begin="n*0.2 + 's'" repeatCount="indefinite" />
            </circle>
          </g>
        </svg>
        
        <div class="hud-top">
           <div class="stat">
              <label>高度变化 h ∝ 1/r</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row">
             <label>表面张力系数 (γ): {{ surfaceTension }}</label>
             <el-slider v-model="surfaceTension" :min="1" :max="100" size="mini"></el-slider>
          </div>
          <div class="row button-group">
             <el-button size="mini" @click="showMolecules = !showMolecules">切换分子视图</el-button>
             <el-checkbox v-model="wetting">由于表面张力产生的浸润</el-checkbox>
          </div>
        </div>

        <div class="discovery-note" v-latex>
          <p><strong>物理详解：</strong>浸润液体在细管中上升（如水于玻璃管），不浸润液体在细管中下降（如水银）。管径越细，高度变化越明显。这是植物吸收水分和地下水上升的重要原因。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CapillaryViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      surfaceTension: 50,
      showMolecules: false,
      wetting: true,
      tubes: [
        { width: 30, radius: '粗', isWetting: true },
        { width: 10, radius: '细', isWetting: true },
        { width: 5, radius: '极细', isWetting: true }
      ]
    }
  },
  methods: {
    calculateLiquidPath(tube, index) {
      const baseX = 100 + index * 100;
      const baseY = 190;
      // High h for small radius
      const factor = this.wetting ? 1 : -1;
      const height = (50 / tube.width) * (this.surfaceTension / 50) * factor;
      const topY = baseY - height;
      
      return `M ${baseX} ${baseY} 
              L ${baseX + tube.width} ${baseY} 
              L ${baseX + tube.width} ${topY} 
              Q ${baseX + tube.width/2} ${topY + (this.wetting ? 5 : -5)} ${baseX} ${topY} 
              Z`;
    }
  }
}
</script>

<style scoped lang="scss">
.capillary-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.main-layout { flex: 1; display: flex; flex-direction: column; gap: 15px; }
.canvas-box { background: #000; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.hud-top { position: absolute; top: 15px; left: 15px; .stat label { font-size: 0.7rem; color: #00d2ff; text-transform: uppercase; letter-spacing: 1px; } }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; 
  label { font-size: 0.7rem; color: #888; display: block; margin-bottom: 5px; } 
  .button-group { margin-top: 10px; display: flex; align-items: center; gap: 20px; }
}
.discovery-note { background: rgba(0, 210, 255, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
